import * as React from "react";
import { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { _get } from "../Api";
import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import { Button, IconButton } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { Edit } from "@material-ui/icons";
import { useDialog } from "../components/Dialogs/DialogProvider";
import MakeRuleDialog from "../components/MaxOrdersPerBlock/MakeRuleDialog";
import { updateTaMerchants } from "../store/TaMerchantApi";
import { setMerchant } from "../store/CloudActions";
import { days } from "../components/OpeningHours/WeekHours";

const fetchData = (id) => {
  return _get("/nova/ta_merchant/" + id + "/timeblocks")
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      console.log(e);
    });
};

function MaxOrderPerBlock() {
  const taMerchantId = Number.parseInt(useParams().taMerchantId);
  const [openDialog] = useDialog();
  const [taMerchant, setTaMerchant] = useState(
    cloudStore.merchant.ta_merchants.find((ta_merchant) => ta_merchant.id === taMerchantId)
  );
  const [rules, setRules] = React.useState(taMerchant.max_ta_orders);

  useEffect(() => {
    function onChange() {}

    cloudStore.on(cloudStoreEvents.MERCHANT_UPDATED, onChange);
    if (cloudStore.merchant != null) {
      onChange();
    }
    return () => cloudStore.removeListener(cloudStoreEvents.MERCHANT_UPDATED, onChange);
  }, [taMerchantId]);

  useEffect(() => {
    setTaMerchant(cloudStore.merchant.ta_merchants.find((ta_merchant) => ta_merchant.id === taMerchantId));
  }, [taMerchantId]);
  useEffect(() => {
    if (taMerchant) {
      setRules(taMerchant.max_ta_orders ?? []);
    } else {
      setRules(null);
    }
  }, [taMerchant]);

  return (
    <Paper variant={"outlined"} style={{ padding: 8 }}>
      <Typography variant="h4" style={{ marginBottom: 20 }}>
        Settings - {cloudStore.merchant.name}
      </Typography>

      <Grid container spacing={1}>
        <Grid item xs={4}>
          Day
        </Grid>
        <Grid item xs={4}>
          From time of day
        </Grid>
        <Grid item xs={4}>
          Upto time of day
        </Grid>
        <Grid item xs={12}>
          <Divider style={{ margin: 20 }} />
        </Grid>
        {rules
          ?.sort((a, b) => {
            let dayIndexA = days.indexOf(a.day);
            let dayIndexB = days.indexOf(b.day);
            if (dayIndexA < dayIndexB) {
              return -1;
            }
            if (dayIndexA > dayIndexB) {
              return 1;
            }
            return a.from.localeCompare(b.from);
          })
          .map((rule, index) => {
            return (
              <>
                <Grid item xs={4}>
                  {rule.day}
                </Grid>
                <Grid item xs={4}>
                  {rule.from}
                </Grid>
                <Grid item xs={4}>
                  {rule.upto}
                </Grid>
                <Grid item xs={5}>
                  Max takeaway orders: {rule.takeaway ?? "No limit"}
                </Grid>
                <Grid item xs={5}>
                  Max delivery orders: {rule.delivery ?? "No limit"}
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => {
                      openDialog({
                        children: (
                          <MakeRuleDialog
                            rule={rule}
                            onSave={(newRule) => {
                              let newRules = [...rules];
                              if (newRule) {
                                newRules.splice(index, 1, newRule);
                              } else {
                                newRules.splice(index, 1);
                              }
                              setRules(newRules);
                            }}
                          />
                        ),
                      });
                    }}
                  >
                    <Edit />
                  </IconButton>
                </Grid>
                <Grid item xs={12}>
                  <Divider style={{ margin: 20 }} />
                </Grid>
              </>
            );
          })}
        <Grid item xs={12} container alignItems={"flex-end"}>
          <Button
            variant={"outlined"}
            onClick={() => {
              openDialog({
                children: (
                  <MakeRuleDialog
                    rule={{ delivery: null, takeaway: null }}
                    onSave={(newRule) => {
                      if (newRule) {
                        setRules([...rules, newRule]);
                      }
                    }}
                  />
                ),
              });
            }}
          >
            New
          </Button>
          <Button
            variant={"outlined"}
            onClick={() => {
              updateTaMerchants([taMerchant], [{ max_ta_orders: rules }]).then((taMerchants) => {
                let merchant = cloudStore.merchant;
                let index = merchant.ta_merchants.findIndex((ta_merchant) => ta_merchant.id === taMerchants[0].id);
                if (index > -1) {
                  merchant.ta_merchants[index] = taMerchants[0];
                  setMerchant(merchant);
                }
              });
            }}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default MaxOrderPerBlock;
